var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioWaveformWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 30,
    viewBox: "0 0 80 30",
    fill: "none",
    id: "svg144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 30,
    rx: 1,
    fill: "url(#paint0_linear_6743_23757)",
    id: "rect2",
    x: 0,
    y: 0,
    width: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 5,
    width: 2,
    height: 20,
    rx: 1,
    fill: "url(#paint1_linear_6743_23757)",
    id: "rect4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 9,
    width: 2,
    height: 12,
    rx: 1,
    fill: "url(#paint2_linear_6743_23757)",
    id: "rect6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 2,
    height: 14,
    rx: 1,
    fill: "url(#paint3_linear_6743_23757)",
    id: "rect8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    width: 2,
    height: 30,
    rx: 1,
    fill: "url(#paint4_linear_6743_23757)",
    id: "rect10",
    y: 0
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 2,
    height: 24,
    rx: 1,
    fill: "url(#paint5_linear_6743_23757)",
    id: "rect12"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 10,
    width: 2,
    height: 10,
    rx: 1,
    fill: "url(#paint6_linear_6743_23757)",
    id: "rect14"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 5,
    width: 2,
    height: 20,
    rx: 1,
    fill: "url(#paint7_linear_6743_23757)",
    id: "rect16"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 2,
    width: 2,
    height: 26,
    rx: 1,
    fill: "url(#paint8_linear_6743_23757)",
    id: "rect18"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 5,
    width: 2,
    height: 20,
    rx: 1,
    fill: "url(#paint9_linear_6743_23757)",
    id: "rect20"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 2,
    height: 20,
    rx: 1,
    fill: "url(#paint10_linear_6743_23757)",
    id: "rect22"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 7,
    width: 2,
    height: 16,
    rx: 1,
    fill: "url(#paint11_linear_6743_23757)",
    id: "rect24"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 10,
    width: 2,
    height: 10,
    rx: 1,
    fill: "url(#paint12_linear_6743_23757)",
    id: "rect26"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    width: 2,
    height: 20,
    rx: 1,
    fill: "url(#paint13_linear_6743_23757)",
    id: "rect28"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 3,
    width: 2,
    height: 24,
    rx: 1,
    fill: "url(#paint14_linear_6743_23757)",
    id: "rect30"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 2,
    height: 10,
    rx: 1,
    fill: "url(#paint15_linear_6743_23757)",
    id: "rect32"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 5,
    width: 2,
    height: 20,
    rx: 1,
    fill: "url(#paint16_linear_6743_23757)",
    id: "rect34"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 2,
    width: 2,
    height: 26,
    rx: 1,
    fill: "url(#paint17_linear_6743_23757)",
    id: "rect36"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 2,
    height: 30,
    rx: 1,
    fill: "url(#paint18_linear_6743_23757)",
    id: "rect38",
    y: 0
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 7,
    width: 2,
    height: 16,
    rx: 1,
    fill: "url(#paint19_linear_6743_23757)",
    id: "rect40"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs142"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6743_23757",
    x1: 0,
    y1: 15,
    x2: 2,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop42",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop44",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6743_23757",
    x1: 32,
    y1: 15,
    x2: 34,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop47",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop49",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6743_23757",
    x1: 64,
    y1: 15,
    x2: 66,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop52",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop54",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6743_23757",
    x1: 16,
    y1: 15,
    x2: 18,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop57",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop59",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6743_23757",
    x1: 48,
    y1: 15,
    x2: 50,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop62",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop64",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6743_23757",
    x1: 8,
    y1: 15,
    x2: 10,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop67",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop69",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6743_23757",
    x1: 40,
    y1: 15,
    x2: 42,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop72",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop74",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6743_23757",
    x1: 72,
    y1: 15,
    x2: 74,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop77",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop79",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6743_23757",
    x1: 24,
    y1: 15,
    x2: 26,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop82",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop84",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6743_23757",
    x1: 56,
    y1: 15,
    x2: 58,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop87",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop89",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6743_23757",
    x1: 4,
    y1: 15,
    x2: 6,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop92",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop94",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6743_23757",
    x1: 36,
    y1: 15,
    x2: 38,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop97",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop99",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6743_23757",
    x1: 68,
    y1: 15,
    x2: 70,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop102",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop104",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6743_23757",
    x1: 20,
    y1: 15,
    x2: 22,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop107",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop109",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6743_23757",
    x1: 52,
    y1: 15,
    x2: 54,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop112",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop114",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6743_23757",
    x1: 12,
    y1: 15,
    x2: 14,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop117",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop119",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6743_23757",
    x1: 44,
    y1: 15,
    x2: 46,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop122",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop124",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6743_23757",
    x1: 76,
    y1: 15,
    x2: 78,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop127",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop129",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6743_23757",
    x1: 28,
    y1: 15,
    x2: 30,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop132",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop134",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6743_23757",
    x1: 60,
    y1: 15,
    x2: 62,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7",
    id: "stop137",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF",
    id: "stop139",
    style: {
      stopColor: "#d2e9ff",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioWaveformWhite);
export default __webpack_public_path__ + "static/media/audio_waveform_white.c8b6a3e6dd4fc0c1c003f3c8a7e41938.svg";
export { ForwardRef as ReactComponent };